export function NotFoundBannerCarousel(props: any) {
  return (
    <div className="card border-0 mb-0 pb-0">
      <img
        src=""
        className="w-100 img-fluid desktopImage"
        alt="Banner not found"
      />
      <img
        src=""
        className="w-100 img-fluid mobileImage"
        alt="Banner not found"
      />
      <div className="card-img-overlay text-start">
        <div className="row text-end">
          <div className="col-md-12 carousel-button-demo me-3">
            <div className="template welcomeSlideTemplate"> </div>
          </div>
        </div>
        <div className="row position-absolute bottom-0 end-0 mb-4">
          <div className="col-md-12">
            <h2 className="text-end me-5 pe-5">Banner not found</h2>
          </div>
        </div>
      </div>
    </div>
  );
}
